module.exports = __webpack_public_path__ + "static/media/Battle Mech.792fbffb.jpg";